import Entity from './entity'

export default class TransportDetail extends Entity<number>{
    code:string;
    transportType:string;
    transportTypeName:string;
    statusCode : string;
    statusName: string;
    numOfSlot: number;
    maxProductSizeCode: string;
    lastModificationTime: Date;
    lastModifierUserId: number;
    lastModifierUserName: string;
}